import dayjs from "dayjs";

export const isEndBeforeStart = ( start, end ) => {
    const beginningTime = dayjs( start, "hh:mm" );
    const endTime = dayjs( end, "hh:mm" );
    return endTime.isBefore( beginningTime );
};